import axios from "axios";
import {axiosFormDataConfigs, getFormData} from "../../../../_emywork/helpers/AxiosHelpers";
import {toAbsoluteApiUrl} from "../../../../_metronic/_helpers";

export const API_URI = toAbsoluteApiUrl("/statistics");

export const getUsersStatistics = () => axios.get(`${API_URI}/users`);
export const getTeamsStatistics = () => axios.get(`${API_URI}/teams`);
export const getContactStatistics = () => axios.get(`${API_URI}/contacts`);
export const getEmyProjectsStatistics = () => axios.get(`${API_URI}/emy_projects`);
export const getEmyServicesStatistics = () => axios.get(`${API_URI}/emy_services`);
export const getEmyProductsStatistics = () => axios.get(`${API_URI}/emy_products`);
export const getNotificationsStatistics = () => axios.get(`${API_URI}/notifications`);
export const getWalletStatistics = () => axios.get(`${API_URI}/wallet`);